import axios from 'axios'
import { getHydraUrl, getMenuUrl } from '@/core/http/http-helper'
import type { ProfilePicturePayload } from './profile-picture.helpers'

export interface UploadProfilePictureParams {
    token: string
    country2: string
    file: File | Blob
    fileName?: string
}

interface MenuResponse {
    onself?: {
        ushop?: {
            profile?: {
                profilePicture?: ProfilePicturePayload
                [key: string]: unknown
            }
        }
    }
}

/**
 * POST /v5a/customers/me/profilePicture (multipart/form-data, field name: media).
 * Returns the updated `profilePicture` object that can be merged into customerState.
 */
export const uploadProfilePicture = async ({ token, country2, file, fileName = 'profile.jpg' }: UploadProfilePictureParams): Promise<ProfilePicturePayload> => {
    const form = new FormData()
    const blob = file instanceof File ? file : new File([file], fileName, { type: file.type || 'image/jpeg' })
    form.append('media', blob, fileName)

    const response = await axios.post<ProfilePicturePayload>(getHydraUrl('v5a/customers/me/profilePicture'), form, {
        headers: {
            authorization: `Bearer ${token}`,
            'X-Application': `asia.fg.${country2.toLowerCase()}`,
            'Content-Type': 'multipart/form-data'
        }
    })

    return response.data
}

/**
 * GET `etlV2/menu?...&byPassCache=1` and pluck `onself.ushop.profile.profilePicture`.
 * Returns `undefined` on any failure or when no fresh picture is available.
 */
export const fetchProfilePictureFromMenu = async ({
    token,
    countryAlpha3,
    baId
}: {
    token: string
    countryAlpha3: string
    baId: string
}): Promise<ProfilePicturePayload | undefined> => {
    if (!token || !baId || !countryAlpha3) return undefined
    try {
        const url = `${getMenuUrl(countryAlpha3, baId)}&byPassCache=1`
        const response = await axios.get<MenuResponse>(url, {
            headers: { 'authorization-hydra': `Bearer ${token}` }
        })
        return response.data?.onself?.ushop?.profile?.profilePicture
    } catch (err) {
        console.warn('fetchProfilePictureFromMenu failed', err)
        return undefined
    }
}
